import React, { useEffect } from "react";
import Header from "./components/dashboard/header";
import Footer from "./components/dashboard/footer";
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

/* ── Page transition wrapper ── */
function PageTransition({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div key={location.pathname}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -16 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function Home() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <PageTransition>
        <Outlet />
      </PageTransition>
      <Footer />
    </>
  );
}

export default Home;
